import { useContext } from "react";
import { COMPLIANCE_DOCUMENTS_OPTIONS } from "../../orderScheduler/const";
import { CustomerContext } from "./CustomerPage";

const OrderPlanningView = () => {
  const { customer, save } = useContext(CustomerContext);

  const requiredCertificateTypes = customer.requiredCertificateTypes
    ? Array.from(
        new Set(
          customer.requiredCertificateTypes
            .split(",")
            .map((i) => i.trim())
            .filter(Boolean),
        ),
      )
    : [];

  function updateRequiredCertificateTypes(option, checked) {
    const newRequiredCertificateTypes = checked
      ? [...requiredCertificateTypes, option]
      : requiredCertificateTypes.filter((i) => i !== option);
    const requiredCertificateTypesString = newRequiredCertificateTypes.join(",");

    save({
      variables: {
        id: customer.id,
        requiredCertificateTypes: requiredCertificateTypesString,
      },
      optimisticResponse: {
        updateCustomer: {
          customer: {
            ...customer,
            requiredCertificateTypes: requiredCertificateTypesString,
          },
          __typename: "UpdateCustomer",
        },
      },
    });
  }

  return (
    <div className="card">
      <h5>Order Planning</h5>
      <div className="mt-2">
        <div>
          <div className="flex items-center space-x-3">
            <label htmlFor="skip-customer-stages">Skip Customer Stages: </label>
            <input
              id="skip-customer-stages"
              type="checkbox"
              checked={customer.skipCustomerConfirmationForPlan}
              onChange={() =>
                save({
                  variables: {
                    id: customer.id,
                    skipCustomerConfirmationForPlan:
                      !customer.skipCustomerConfirmationForPlan,
                  },
                  optimisticResponse: {
                    updateCustomer: {
                      customer: {
                        ...customer,
                        skipCustomerConfirmationForPlan:
                          !customer.skipCustomerConfirmationForPlan,
                      },
                      __typename: "UpdateCustomer",
                    },
                  },
                })
              }
            />
          </div>

          <div className="mt-1 opacity-70">
            When enabled, you don't need to confirm the order with the customer
            in Order Scheduler. This is useful for customers who don't require
            confirmation. For now, it is useful for Waboba INC.
          </div>
        </div>

        <div className="mt-4">
          <div className="flex items-center space-x-4 flex-wrap">
            <label className="pr-1">Required Certificates:</label>
            {COMPLIANCE_DOCUMENTS_OPTIONS.map((option) => (
              <div key={option} className="flex items-center space-x-2">
                <input
                  id={`required-certificate-types-${option}`}
                  type="checkbox"
                  checked={requiredCertificateTypes.includes(option)}
                  onChange={(e) =>
                    updateRequiredCertificateTypes(option, e.target.checked)
                  }
                />
                <label htmlFor={`required-certificate-types-${option}`}>
                  {option}
                </label>
              </div>
            ))}
          </div>

          <div className="mt-1 opacity-70">
            Selected certificates are used for compliance validation in Order
            Scheduler.
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderPlanningView;
